import { render, staticRenderFns } from "./ListContactLists.vue?vue&type=template&id=363cf4f8&"
import script from "./ListContactLists.vue?vue&type=script&lang=js&"
export * from "./ListContactLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports